import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import "./ConsultantContainer.css";

class VenueChipsDisplay extends Component {
    state = {
        showPopover: false
    };

    togglePopover = (e) => {
        e.stopPropagation();
        this.setState({ showPopover: !this.state.showPopover });
    };

    closePopover = () => {
        this.setState({ showPopover: false });
    };

    getInitialVenues = () => {
        const { venues, maxVisible = 2 } = this.props;
        if (!venues || venues.length === 0) return [];
        return venues.slice(0, maxVisible);
    };

    getRemainingCount = () => {
        const { venues, maxVisible = 2 } = this.props;
        if (!venues) return 0;
        return Math.max(0, venues.length - maxVisible);
    };

    render() {
        const { venues, label = "Managed Venues" } = this.props;
        const { showPopover } = this.state;
        const initialVenues = this.getInitialVenues();
        const remainingCount = this.getRemainingCount();

        if (!venues || venues.length === 0) {
            return (
                <div className="consultant-venues">
                    <div className="consultant-venues-label">{label}</div>
                    <div className="venue-chips">
                        <span style={{ color: '#999', fontSize: 12 }}>No venues assigned</span>
                    </div>
                </div>
            );
        }

        return (
            <div className="consultant-venues">
                <div className="consultant-venues-label">{label}</div>
                <div className="venue-chips">
                    {initialVenues.map((venue, index) => (
                        venue.id ? (
                            <Link
                                key={venue.id || index}
                                to={`/profile/${venue.id}`}
                                className="venue-chip"
                            >
                                {venue.profileName || venue.fullName || venue.name || "Unknown Venue"}
                            </Link>
                        ) : (
                            <span key={index} className="venue-chip">
                                {venue.profileName || venue.fullName || venue.name || "Unknown Venue"}
                            </span>
                        )
                    ))}
                    {remainingCount > 0 && (
                        <button
                            className="venue-chip more"
                            onClick={this.togglePopover}
                        >
                            +{remainingCount} more
                        </button>
                    )}
                </div>
                {showPopover && (
                    <Fragment>
                        <div className="venues-popover-overlay" onClick={this.closePopover} />
                        <div className="venues-popover">
                            <div className="venues-popover-header">
                                All {venues.length} {label}
                            </div>
                            <div className="venues-popover-list">
                                {venues.map((venue, index) => (
                                    venue.id ? (
                                        <Link
                                            key={venue.id || index}
                                            to={`/profile/${venue.id}`}
                                            className="venue-chip"
                                            onClick={this.closePopover}
                                        >
                                            {venue.profileName || venue.fullName || venue.name || "Unknown Venue"}
                                        </Link>
                                    ) : (
                                        <span key={index} className="venue-chip">
                                            {venue.profileName || venue.fullName || venue.name || "Unknown Venue"}
                                        </span>
                                    )
                                ))}
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }
}

export default VenueChipsDisplay;
